export const hasVisibleText = (text: string | null | undefined): boolean =>
	(text ?? "")
		.replace(/<[^>]*>/g, "")
		.replace(/&nbsp;/gi, " ")
		.trim() !== "";
